import Resource from "./resource";
import {appContainer} from "../contexts/app";
import {List} from "immutable";

export default function FloorRecordFactory(service) {
  const FloorRecord = Resource(
    service,
    {
      account_id: "",
      building_id: "",
      name: "",
      geo: {},
      overlay: {
        image: {
          path: "https://via.placeholder.com/400x400",
          name: "",
          key: ""
        },
        heading: 0,
        opacity: 1
      }
    },
    {
      markers() {
        const markers = appContainer.state.get("markers");
        if (!markers) {
          return List();
        }
        return markers.toList().filter(marker => marker.floor_id === this._id);
      },

      getPath() {
        return `buildings/${this.building_id}/floors/${this._id}`;
      },

      getTypeName() {
        FloorRecord.getTypeName();
      },

      getResource() {
        return FloorRecord;
      }
    }
  );

  FloorRecord.getTypeName = function() {
    return "floor";
  };

  return FloorRecord;
}



// WEBPACK FOOTER //
// ./src/feathers/floor-record.js